import React from 'react';
import Cookies from 'js-cookie';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import LayoutWithSidebar from './Layout';
import LayoutClientView from './LayoutClientView/Layout';
import LayoutWithoutSidebar from './LayoutWithoutSidebar/LayoutWithoutSidebar';
import Login from '../pages/login';
import Error from '../pages/error';

export default function App() {
    const isAuthenticated = () => {
        if (Cookies.get('email') && Cookies.get('user_id')) {
            return true;
        }
        return false;
    };

    const isAdmin = () => {
        if (
            ['searchunify.com', 'grazitti.com'].includes(
                Cookies.get('email').split('@')[1]
            )
        ) {
            return true;
        }
        return false;
    };

    function PrivateRoute({ component, ...rest }) {
        return (
            <Route
                {...rest}
                render={(props) =>
                    isAuthenticated() && isAdmin() ? (
                        React.createElement(component, props)
                    ) : (
                        <Redirect
                            to={{
                                pathname: '/'
                            }}
                        />
                    )
                }
            />
        );
    }

    function ClientRoute({ component, ...rest }) {
        return (
            <Route
                {...rest}
                render={(props) =>
                    isAuthenticated() ? (
                        React.createElement(component, props)
                    ) : (
                        <Redirect
                            to={{
                                pathname: '/'
                            }}
                        />
                    )
                }
            />
        );
    }

    function PublicRoute({ component, ...rest }) {
        return (
            <Route
                {...rest}
                render={(props) =>
                    // eslint-disable-next-line no-nested-ternary
                    isAuthenticated() ? (
                        isAdmin() ? (
                            <Redirect
                                to={{
                                    pathname: '/app/dashboard'
                                }}
                            />
                        ) : (
                            <Redirect
                                to={{
                                    pathname: '/status-page'
                                }}
                            />
                        )
                    ) : (
                        React.createElement(component, props)
                    )
                }
            />
        );
    }

    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/" render={() => <Redirect to="/login" />} />
                <PrivateRoute path="/app" component={LayoutWithSidebar} />
                <PrivateRoute path="/instances" component={LayoutWithoutSidebar} />
                <ClientRoute path="/status-page" component={LayoutClientView} />
                <PublicRoute path="/login" component={Login} />
                <Route component={Error} />
            </Switch>
        </BrowserRouter>
    );
}
